import { Link } from 'react-router';
import { useLiveQuery } from 'dexie-react-hooks';
import { Infinity as Infinito, UserRound } from 'lucide-react';
import { leerSettings } from '@/db/schema';
import { SelectorTema } from '@/features/apariencia/SelectorTema';

/** Inicial del nombre del perfil, o null si no hay nombre. */
function inicial(nombre: string | null): string | null {
  const limpio = nombre?.trim() ?? '';
  return limpio === '' ? null : limpio.slice(0, 1).toLocaleUpperCase('es-MX');
}

/**
 * Encabezado de Foco: la marca, el sol y la luna para el tema y el acceso al
 * perfil. Respeta el área segura del iPhone (Dynamic Island).
 *
 * `conPerfil` es false en Primeros pasos, donde el perfil todavía no existe.
 */
export function Encabezado({ conPerfil = true }: { conPerfil?: boolean }) {
  const nombre = useLiveQuery(async () => (await leerSettings()).nombre, []);
  const letra = inicial(nombre ?? null);

  return (
    <header className="flex items-center justify-between gap-2 px-4 pb-3 pt-[19px] min-[401px]:px-[22px] min-[401px]:pb-4 min-[401px]:pt-[22px]">
      <div className="flex items-center gap-1 text-[19px] font-medium tracking-[-0.9px] text-texto min-[401px]:gap-1.5 min-[401px]:text-[20px]">
        <Infinito className="size-[25px] text-marca" />
        DuoFit
      </div>
      <div className="flex items-center gap-1.5 min-[401px]:gap-2.5">
        <SelectorTema />
        {conPerfil && (
          <Link
            to="/mas/perfil"
            aria-label="Abrir mi perfil"
            className="grid size-11 place-items-center rounded-full"
          >
            <span
              aria-hidden="true"
              className="grid size-9 place-items-center rounded-full bg-marca-suave text-[13px] font-medium text-marca"
            >
              {letra ?? <UserRound className="size-[18px]" />}
            </span>
          </Link>
        )}
      </div>
    </header>
  );
}
